/**
 * Format date string to human readable format
 * Date string format: 'YYYY-MM-DD'
 */
export default function formatDate(dateString: string, locale = 'bg-BG') {
    const date = new Date(dateString)

    return new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(date)
}
